import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

import { fetchCRMSettings } from 'app/pages/CRMSettingsComponent/data/crmSettingsDataService';
import {
  CrmProviderOption,
  FALLBACK_CRM_PROVIDER_OPTIONS,
  getCrmProviderOptions,
  getDefaultUploadDateRange,
  getLatestActiveCrmProvider,
} from 'app/pages/RunLogsPage/utils/uploadModalDefaults';

export function useUploadModalDefaults(open: boolean, dealerId: string) {
  const [providerOptions, setProviderOptions] = useState<CrmProviderOption[]>(
    FALLBACK_CRM_PROVIDER_OPTIONS,
  );
  const [defaultProvider, setDefaultProvider] = useState('');
  const [defaultDateRange, setDefaultDateRange] = useState<
    [DateTime | null, DateTime | null]
  >(() => {
    const [start, end] = getDefaultUploadDateRange();
    return [start, end];
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !dealerId) {
      return;
    }

    const [start, end] = getDefaultUploadDateRange();
    setDefaultDateRange([start, end]);
    setLoading(true);

    fetchCRMSettings({ dealershipId: dealerId })
      .then(response => {
        const settings = response?.body?.[0]?.settings || [];
        const options = getCrmProviderOptions(settings);

        setProviderOptions(
          options.length > 0 ? options : FALLBACK_CRM_PROVIDER_OPTIONS,
        );
        setDefaultProvider(getLatestActiveCrmProvider(settings));
      })
      .catch(() => {
        setProviderOptions(FALLBACK_CRM_PROVIDER_OPTIONS);
        setDefaultProvider('');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [open, dealerId]);

  return {
    providerOptions,
    defaultProvider,
    defaultDateRange,
    loading,
  };
}
